import { render, staticRenderFns } from "./BusinessSettings.vue?vue&type=template&id=deaa266e&scoped=true&"
import script from "./BusinessSettings.vue?vue&type=script&lang=js&"
export * from "./BusinessSettings.vue?vue&type=script&lang=js&"
import style0 from "./BusinessSettings.vue?vue&type=style&index=0&id=deaa266e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "deaa266e",
  null
  
)

export default component.exports